export default "__VITE_ASSET__6BtV9EgU__"